import { Brands as Page } from './Brands.main';
import { BrandsHeader as Header } from './BrandsHeader';

export { Filters } from './Filters';
export { BrandsTable } from './BrandsTable';

export const Brands = { Header, Page };
